// import { Avatar } from '@mantine/core'
// import { Typography } from '../common/typography'
// import classes from './Arena.module.css'
// import { ArenaPost } from './api'

// export default function RoarPostCover({
//   authors,
//   posts,
// }: {
//   authors: (string | null)[]
//   posts: ArenaPost[]
// }) {
//   const postsToShow = Math.min(posts.length, 3)
//   const uniqueAuthors = Array.from(new Set(posts.map((post) => post.user_id)))
//   const remainingPosts =
//     uniqueAuthors.length - (uniqueAuthors.length > 4 ? 3 : uniqueAuthors.length)
//   const displayAuthors = posts
//     .slice(0, postsToShow)
//     .map((post) => post.user_photo)

//   if (displayAuthors.length > 4) {
//     displayAuthors.push(null)
//   }
//   const authorsToDisplay = Math.min(authors.length, 3)
//   const remainingCount =
//     authors.length - (authors.length > 4 ? 3 : authors.length)

//   const displayAvatars = authors.slice(0, authorsToDisplay)

//   if (authors.length > 4) {
//     displayAvatars.push(null)
//   }

//   return (
//     <div className={classes.roarPostCoverContainer}>
//       <div className={classes.roarPostCoverBanner}>
//         <Typography
//           fs="xl"
//           fc={{ light: 'white', dark: 'white' }}
//           lh="160"
//           ta="center"
//           tt="uppercase"
//           us="none"
//         >
//           Roar
//         </Typography>
//       </div>
//       <Typography
//         fs="sm"
//         fw={500}
//         fc={{ light: 'white', dark: 'white' }}
//         lh="115"
//         ta="center"
//         tt="uppercase"
//         us="none"
//       >
//         Roars that you missed
//       </Typography>
//       <div className={classes.authorsContainer}>
//         {displayAvatars.map((author) => {
//           if (author === null) {
//             return (
//               <Avatar
//                 key="remaining-count"
//                 className={classes.author}
//                 classNames={{ placeholder: classes.authorPlaceholder }}
//               >
//                 +{remainingCount}
//               </Avatar>
//             )
//           }

//           return <Avatar key={author} src={author} className={classes.author} />
//         })}
//       </div>
//     </div>
//   )
// }

import { Avatar } from '@mantine/core'
import { Typography } from '../common/typography'
import classes from './Arena.module.css'
import { ArenaPost } from './api'

interface AuthorData {
  id: number
  photo: string | null
  first_name: string
  last_name: string
}

export default function RoarPostCover({ posts }: { posts: ArenaPost[] }) {
  const uniqueAuthorsMap = new Map<number, AuthorData>()

  posts.forEach((post) => {
    if (!uniqueAuthorsMap.has(post.user_id)) {
      uniqueAuthorsMap.set(post.user_id, {
        id: post.user_id,
        photo: post.user_photo,
        first_name: post.user_first_name,
        last_name: post.user_last_name,
      })
    }
  })

  const uniqueAuthorsData = Array.from(uniqueAuthorsMap.values())

  const MAX_DISPLAY_AUTHORS = 3
  const totalUniqueAuthors = uniqueAuthorsData.length

  const authorsToDisplayCount = Math.min(
    totalUniqueAuthors,
    MAX_DISPLAY_AUTHORS
  )

  const remainingCount =
    totalUniqueAuthors > MAX_DISPLAY_AUTHORS
      ? totalUniqueAuthors - MAX_DISPLAY_AUTHORS
      : 0

  const displayAvatarsData = uniqueAuthorsData.slice(0, authorsToDisplayCount)

  if (remainingCount > 0) {
    displayAvatarsData.push(null as unknown as AuthorData)
  }

  function getInitials(firstName: string, lastName: string): string {
    const first = firstName?.charAt(0)?.toUpperCase() || ''
    const last = lastName?.charAt(0)?.toUpperCase() || ''
    return `${first}${last}` || ''
  }

  return (
    <div className={classes.roarPostCoverContainer}>
      <div className={classes.roarPostCoverBanner}>
        <Typography
          fs="xl"
          fc={{ light: 'white', dark: 'white' }}
          lh="160"
          ta="center"
          tt="uppercase"
          us="none"
        >
          Roar
        </Typography>
      </div>
      <Typography
        fs="sm"
        fw={500}
        fc={{ light: 'white', dark: 'white' }}
        lh="115"
        ta="center"
        tt="uppercase"
        us="none"
      >
        Roars that you missed
      </Typography>
      <div className={classes.authorsContainer}>
        {displayAvatarsData.map((authorData, index) => {
          if (
            !authorData ||
            (remainingCount > 0 && index === displayAvatarsData.length - 1)
          ) {
            return (
              <Avatar
                key="remaining-count"
                className={classes.author}
                classNames={{ placeholder: classes.authorPlaceholder }}
              >
                +{remainingCount}
              </Avatar>
            )
          }

          return (
            <Avatar
              key={authorData.id}
              src={authorData.photo}
              className={classes.author}
              classNames={{ placeholder: classes.authorPlaceholder }}
            >
              {getInitials(authorData.first_name, authorData.last_name)}
            </Avatar>
          )
        })}
      </div>
    </div>
  )
}
